import { getNumericMetric } from '@utils/metrics/rateMetrics';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { metricSelector } from '@store/metricsChartContainer/selectors';
import ignoreRefetch from '@utils/metrics/ignoreRefetch';
import { queryMetricsAtom } from '../atoms';
import { getPercentageMetricByKey } from '@utils/metrics/metricHelpers';

// build and manage local list of query metrics to reduce refetches
// Metric call metric panel
function useQueryMetrics() {
  const metrics = useSelector(metricSelector);
  const [queryMetrics, setQueryMetrics] = useAtom(queryMetricsAtom);

  useEffect(() => {
    // query toggle metrics(count => pct) if available
    let currentQueryMetrics = [...metrics];
    metrics.forEach((m) => {
      currentQueryMetrics.push(getNumericMetric(m));
      const invertedMetric = getPercentageMetricByKey({ metricKey: m, defaultValue: null });
      if (invertedMetric) {
        currentQueryMetrics.push(invertedMetric);
      }
    });

    currentQueryMetrics = [...new Set(currentQueryMetrics)];
    // to avoid DnD causing a query trigger
    currentQueryMetrics.sort();

    if (!ignoreRefetch(currentQueryMetrics, queryMetrics)) {
      setQueryMetrics(currentQueryMetrics);
    }
  }, [metrics]);
}

export default useQueryMetrics;
